import React from 'react';
import styles from './styles/PDFPreviewModal.module.css';

const PDFPreviewModal = ({ url, onClose }) => {
    return (
        <div className={styles.overlay}>
            <div className={styles.header}>
                <h3 className={styles.title}>PDF Preview</h3>
                <button className={styles.closeButton} onClick={onClose}>Close</button>
            </div>
            <div className={styles.iframeContainer}>
                <iframe
                    src={`${url}#toolbar=0&navpanes=0&scrollbar=0`}
                    className={styles.iframe}
                    title="PDF Preview"
                />
            </div>
        </div>
    );
};

export default PDFPreviewModal;
